import { render, staticRenderFns } from "./FBMOrder.vue?vue&type=template&id=bf390ea4&scoped=true&"
import script from "./FBMOrder.vue?vue&type=script&lang=js&"
export * from "./FBMOrder.vue?vue&type=script&lang=js&"
import style0 from "./FBMOrder.vue?vue&type=style&index=0&id=bf390ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf390ea4",
  null
  
)

export default component.exports